import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddAmountModal from './AddAmountModal';
import { NftInterface } from './types';

export default function NFTActionMenu({ nft }: { nft: NftInterface }) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [addModalOpen, setAddModalOpen] = React.useState(false);

  const menuOpen = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAddAmount = () => {
    handleMenuClose();
    setAddModalOpen(true);
  };

  const handleAddModalClose = () => {
    setAddModalOpen(false);
  };

  return (
    <div>
        <AddAmountModal open={addModalOpen} onClose={handleAddModalClose} nft={nft} />
        <IconButton
            id="basic-button"
            aria-controls={menuOpen ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={menuOpen ? 'true' : undefined}
            onClick={handleMenuClick}
        >
            <MoreVertIcon />
        </IconButton>
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem sx={{px: 4}} onClick={handleAddAmount}>Add Amount</MenuItem>
        </Menu>
    </div>
  );
}
